(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var closeBtn = document.getElementById('sticky-atc-close-btn-custom');
    var stickyAtcContainer = document.querySelector('sticky-atc-container');
    var localStorageKey = 'stick-cta-closed';

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (stickyAtcContainer) {
          stickyAtcContainer.style.display = 'none';
        }
        var expires = Date.now() + 24 * 60 * 60 * 1000; // 24 hours
        localStorage.setItem(localStorageKey, JSON.stringify({ expires: expires }));
        document.body.classList.add('sticky-cta-closed');
      });
    }

    // AB Test Logic: Sticky ATC Mobile
    var abContainer = document.querySelector('.sticky-atc-mobile-ab');
    if (abContainer) {
      var input = abContainer.querySelector('.qty-input');
      var minusBtn = abContainer.querySelector('.qty-btn.minus');
      var plusBtn = abContainer.querySelector('.qty-btn.plus');
      var addToCartBtn = abContainer.querySelector('.add-to-cart-btn');
      var stickyPrice = abContainer.querySelector('[data-stickyAdd-price]');

      function formatMoneyLike(cents, template) {
        var value = Math.abs(cents);
        var priceText = String(template || '').trim();
        var numberMatch = priceText.match(/\d[\d.,]*/);

        if (!numberMatch) return priceText;

        var numberText = numberMatch[0];
        var lastComma = numberText.lastIndexOf(',');
        var lastDot = numberText.lastIndexOf('.');
        var decimalSeparator = '';
        var thousandsSeparator = '';
        var lastSeparator = Math.max(lastComma, lastDot);

        if (lastSeparator > -1 && numberText.length - lastSeparator - 1 <= 2) {
          decimalSeparator = numberText.charAt(lastSeparator);
          thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
        } else if (lastComma > -1 || lastDot > -1) {
          thousandsSeparator = lastComma > -1 ? ',' : '.';
        }

        var integerValue = Math.floor(value / 100);
        var integerText = String(integerValue);

        if (thousandsSeparator && numberText.includes(thousandsSeparator)) {
          integerText = integerText.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        }

        var formattedNumber = integerText;

        return priceText.slice(0, numberMatch.index) + formattedNumber + priceText.slice(numberMatch.index + numberText.length);
      }

      function getQuantity() {
        return Math.max(parseInt(input && input.value, 10) || 1, 1);
      }

      function refreshUnitPriceFromMarkup() {
        if (!stickyPrice) return;

        var renderedPrice = stickyPrice.querySelector('.price');
        var unitPrice = stickyPrice.dataset.unitPrice || (renderedPrice && renderedPrice.dataset.priceCents);
        var unitCompareAtPrice =
          stickyPrice.dataset.unitCompareAtPrice || (renderedPrice && renderedPrice.dataset.compareAtPriceCents);

        if (unitPrice) stickyPrice.dataset.unitPrice = unitPrice;
        if (unitCompareAtPrice) stickyPrice.dataset.unitCompareAtPrice = unitCompareAtPrice;
      }

      function updateStickyPriceTotal() {
        if (!stickyPrice) return;

        refreshUnitPriceFromMarkup();

        var quantity = getQuantity();
        var unitPrice = parseInt(stickyPrice.dataset.unitPrice, 10) || 0;
        var unitCompareAtPrice = parseInt(stickyPrice.dataset.unitCompareAtPrice, 10) || 0;
        var totalPrice = Math.floor(unitPrice / 100) * 100 * quantity;
        var totalCompareAtPrice = Math.floor(unitCompareAtPrice / 100) * 100 * quantity;

        stickyPrice
          .querySelectorAll('.price-item--sale, .price-item--last, .price__regular .price-item--regular:not(s)')
          .forEach(function (priceElement) {
            if (!priceElement.dataset.unitPriceText) {
              priceElement.dataset.unitPriceText = priceElement.textContent;
            }

            priceElement.textContent = formatMoneyLike(totalPrice, priceElement.dataset.unitPriceText);
          });

        stickyPrice.querySelectorAll('s.price-item--regular').forEach(function (comparePriceElement) {
          if (!comparePriceElement.dataset.unitPriceText) {
            comparePriceElement.dataset.unitPriceText = comparePriceElement.textContent;
          }

          comparePriceElement.textContent =
            totalCompareAtPrice > totalPrice ? formatMoneyLike(totalCompareAtPrice, comparePriceElement.dataset.unitPriceText) : '';
        });
      }

      if (minusBtn && input) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(input.value) || 1;
          if (val > 1) {
            input.value = val - 1;
            updateStickyPriceTotal();
          }
        });
      }

      if (plusBtn && input) {
        plusBtn.addEventListener('click', function () {
          var val = parseInt(input.value) || 1;
          input.value = val + 1;
          updateStickyPriceTotal();
        });
      }

      if (input) {
        input.addEventListener('change', updateStickyPriceTotal);
        input.addEventListener('input', updateStickyPriceTotal);
      }

      document.addEventListener('sticky-atc:price-unit-change', updateStickyPriceTotal);

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var qty = parseInt(input.value) || 1;

          // Find main product form elements
          var mainForm = document.querySelector('form[action*="/cart/add"]');
          var mainQtyInput = mainForm ? mainForm.querySelector('input[name="quantity"]') : null;
          var mainAddBtn = mainForm ? mainForm.querySelector('[name="add"]') : null;

          // Fallback global search
          if (!mainQtyInput) mainQtyInput = document.querySelector('input[name="quantity"]');
          if (!mainAddBtn) mainAddBtn = document.querySelector('button[name="add"]');

          if (mainQtyInput) {
            mainQtyInput.value = qty;
            mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          }

          if (mainAddBtn) {
            mainAddBtn.click();
          } else if (mainForm) {
            mainForm.submit();
          } else {
            console.error('Sticky ATC: Could not find main add to cart button or form.');
          }
        });
      }

      updateStickyPriceTotal();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
